import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getName } from "country-list";
import ReactCountryFlag from "react-country-flag";
import { Skeleton } from "primereact/skeleton";
import { fetchEntityDetail } from "~/components/global-entities/globalEntitiesSlice";
import Layout from "~/Layout";

const EmployeeLayout = ({ children, isOnboarding = false }) => {
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchEntityDetail(id))
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);
  const entityData = useSelector((state) => state.globalEntities.entity_detail);

  return (
    <Layout
      crumbs={[
        {
          label: <span className="breadcrumb-link">My Entities</span>,
          command: () => navigate("/entities"),
          id: "My Entities",
        },
        {
          label: (
            <div className="flex breadcrumb-link">
              {!loading ? (
                entityData?.name
              ) : (
                <Skeleton width="100px" height="20px" className="mr-1" />
              )}
              {!loading ? (
                " "
              ) : (
                <Skeleton width="10px" height="20px" className="mr-1" />
              )}
              {!loading ? (
                <>
                  (
                  <ReactCountryFlag
                    countryCode={entityData?.country || ""}
                    svg
                    className=""
                  />{" "}
                  {getName(entityData?.country || "")})
                </>
              ) : (
                <Skeleton width="150px" height="20px" className="mr-1" />
              )}
            </div>
          ),
          command: () => navigate(`/entity/${id}/dashboard`),
          id: "Entities",
        },
        {
          label: (
            <span className={`${isOnboarding ? "breadcrumb-link" : ""}`}>
              Employee Registry
            </span>
          ),
          id: "Employee Registry",
          ...(isOnboarding
            ? { command: () => navigate(`/entity/${id}/employee`) }
            : {}),
        },
        ...(isOnboarding
          ? [
              {
                label: "Add New Employee",
                id: "Add New Employee",
              },
            ]
          : []),
      ]}
    >
      {children}
    </Layout>
  );
};
export default EmployeeLayout;
